import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function VendorsViewModal({
  vendoresId,
  viewvendordata,
  open,
  close,
}) {
  const [suppliername, setSupplierName] = useState("");
  const [suppliernumber, setSupplierNumber] = useState("");
  const [suppliertype, setSupplierType] = useState("");
  const [supplieraddress, setSupplierAddress] = useState("");

  useEffect(() => {
    setSupplierName(viewvendordata?.supplierName);
    setSupplierNumber(viewvendordata?.supplierNumber);
    setSupplierType(viewvendordata?.supplierType);
    setSupplierAddress(viewvendordata?.supplierAddress);
  }, [viewvendordata]);

  return (
    <div>
      {open ? (
        <BootstrapDialog
          className="supplier-modal-wrap modal-wrap"
          onClose={() => close()}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => close()}
          >
            View Vendor
          </BootstrapDialogTitle>

          <DialogContent dividers>
            <div className="row">
              <div className="col-md-12">

                <TextField
                  hidden
                  value={viewvendordata.supplierId ? viewvendordata.supplierId : ""}
                />
              </div>
              <div className="col-md-12">
                <div className="txtfield-wrap">
                  <TextField
                    id="outlined-required"
                    fullWidth
                    label="Vendor Name"
                    value={suppliername ? suppliername : ""}
                    defaultValue={viewvendordata.supplierName}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="txtfield-wrap">
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label="Vendor Conatact Number"
                    value={suppliernumber ? suppliernumber : ""}
                    defaultValue={viewvendordata.supplierNumber}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="txtfield-wrap">
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label="Vendor Type"
                    value={suppliertype ? suppliertype : ""}
                    defaultValue={viewvendordata.supplierType}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="txtfield-wrap">
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label="Vendor Address"
                    value={supplieraddress ? supplieraddress : ""}
                    defaultValue={viewvendordata.supplierAddress}
                    disabled
                  />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="btns-wrapper">
            <Stack spacing={4} direction="row" className="bottom-btn-wrap">
              <Button variant="outlined" onClick={() => close()}>Cancel</Button>
            </Stack>
          </DialogActions>
        </BootstrapDialog>
      ) : null}
    </div>
  );
}
